import { render, staticRenderFns } from "./MyReview.vue?vue&type=template&id=9d83feac&scoped=true"
import script from "./MyReview.vue?vue&type=script&lang=js"
export * from "./MyReview.vue?vue&type=script&lang=js"
import style0 from "./MyReview.vue?vue&type=style&index=0&id=9d83feac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d83feac",
  null
  
)

export default component.exports